import CompensationProfileForm from "@/components/Forms/CompensationProfileForm";
import { useQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router-dom";
import { GET_COMPENSATION_PROFILES_QUERY } from "../../queries";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import { getInitialTotalCompensationProfile } from "@/components/Forms/CompensationProfileForm/initialTotalCompensationProfile";

export default function EditCompensationProfilePage() {
  useRequireCapability({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.manageCompensationProfiles
  });

  const { pgaId, compProfileId } = useParams();
  const navigate = useNavigate();

  const { data: compProfile, loading: compProfileLoading } = useQuery(GET_COMPENSATION_PROFILES_QUERY, {
    variables: {
      pgaId: pgaId
    }
  });

  if (compProfileLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <p className="text-lg font-medium">Loading compensation profile data...</p>
        </div>
      </div>
    );
  }

  const compensationProfiles = compProfile?.person?.compensationProfiles ?? [];
  const defaultValues = compensationProfiles.find((profile: any) => profile.id === compProfileId);
  const initialTotalCompensationProfile = getInitialTotalCompensationProfile(compensationProfiles);

  return (
    <CompensationProfileForm
      onSubmit={() => navigate(`/people/${pgaId}/career/compensation/${compProfileId}/view`)}
      isEdit
      defaultValues={defaultValues}
      pgaId={pgaId}
      contactId={compProfile?.person?.id}
      includeInitialTotalCompensation={defaultValues?.id === initialTotalCompensationProfile?.id}
    />
  );
}
